import SalesOrderDetailContainer from '@components/containers/salesOrders/SalesOrderDetail';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const SalesOrderDetail: FC = () => (
    <AppLayout>
        <SalesOrderDetailContainer />
    </AppLayout>
);

export default SalesOrderDetail;
